import {
	Button,
	Card,
	Col,
	Dialog,
	Progress,
	Row
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VConsole from 'vconsole';
import Vue from 'vue';
import VueMeta from 'vue-meta';
import Toast from 'vue2-toast';
import 'vue2-toast/lib/toast.css';
import App from './App.vue';
import router from './router';
import Func from '@/utils/func'

Vue.config.productionTip = false;
if (process.env.NODE_ENV === 'development') {
	new VConsole()
}

Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(Progress)
Vue.use(Dialog)
Vue.use(VueMeta)

Vue.use(Toast, {
	type: 'center',
	duration: 3000,
	wordWrap: true,
	width: '150px'
})

//全局格式化测试人数
Vue.prototype.formatTestNum = function(num) {
	let iTestNum;
	let current = parseInt(num)
	if (current) {
		if (current <= 10000) {
			iTestNum = current
		} else {
			iTestNum = (current / 10000).toFixed(2) + "W"
		}
	} else {
		iTestNum = 0;
	}
	return iTestNum
}

function goBack() {
	window.location.replace( process.env.VUE_APP_FRONT_URI + '/exam.html#/backlist/list')
}
let sys = Func.platform();

router.beforeEach((to, form, next) => {
    if (to.name == 'home' && sys == 'h5') {
        if (window.history && window.history.pushState) {
            history.pushState(null, null, document.URL);
            window.addEventListener('popstate', goBack, false);
        }
    }
    next();
});

Vue.prototype.startAddEvent = function() {
	if (window.history && window.history.pushState) {
		history.pushState(null, null, document.URL);
		window.addEventListener('popstate', goBack, false);
	}
}

Vue.prototype.stopAddEvent = function() {
	window.removeEventListener('popstate', goBack, false);
}

window.vue = new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
